import { useEffect, useState } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import DocumentUi from "../../../importMedia/DocumentUi";

import Button from "../../../controls/Button";

const initialFValues = {
  name: "",
};

export default function SupplierDetailsForm(props) {
  const { actionCall, supplier, isEdit, setOpen, title } = props;

  const [customerCert1, setCustomerCert1] = useState(null);
  const [customerCert2, setCustomerCert2] = useState(null);
  const [customerCert3, setCustomerCert3] = useState(null);

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues(supplier);
    }
  }, [supplier]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-4">
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="Name"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Contact Name"
              name="contact_name"
              onChange={handleInputChange}
              value={values.contact_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-3 gap-5">
            <Input
              label="Supplier Number"
              name="supplier_number"
              onChange={handleInputChange}
              value={values.supplier_number}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Email"
              name="email"
              onChange={handleInputChange}
              value={values.email}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Phone"
              name="phone"
              onChange={handleInputChange}
              value={values.phone}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-3 gap-5">
            <Input
              label="Address 1"
              name="address_1"
              onChange={handleInputChange}
              value={values.address_1}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Address 2"
              name="address_2"
              onChange={handleInputChange}
              value={values.address_2}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Address 3"
              name="address_3"
              onChange={handleInputChange}
              value={values.address_3}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <Input
              label="City"
              name="city"
              onChange={handleInputChange}
              value={values.city}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Zip"
              name="zip"
              onChange={handleInputChange}
              value={values.zip}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="State"
              name="state"
              onChange={handleInputChange}
              value={values.state}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Country"
              name="country"
              onChange={handleInputChange}
              value={values.country}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-3 gap-2">
            <DocumentUi
              title="Certification 1"
              uploadedImage={customerCert1}
              setUploadedImage={setCustomerCert1}
              isEdit={isEdit}
              imageUrl={values.cert_1_url}
              imageName="cert_1"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_1: "",
                  cert_1_url: null,
                });
                setCustomerCert1(null);
              }}
              showNameInput={true}
              nameInput="cert_1_name"
              nameInputValue={values.cert_1_name}
            />
            <DocumentUi
              title="Certification 2"
              uploadedImage={customerCert2}
              setUploadedImage={setCustomerCert2}
              isEdit={isEdit}
              imageUrl={values.cert_2_url}
              imageName="cert_2"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_2: "",
                  cert_2_url: null,
                });
                setCustomerCert2(null);
              }}
              showNameInput={true}
              nameInput="cert_2_name"
              nameInputValue={values.cert_2_name}
            />
            <DocumentUi
              title="Certification 3"
              uploadedImage={customerCert3}
              setUploadedImage={setCustomerCert3}
              isEdit={isEdit}
              imageUrl={values.cert_3_url}
              imageName="cert_3"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_3: "",
                  cert_3_url: null,
                });
                setCustomerCert3(null);
              }}
              showNameInput={true}
              nameInput="cert_3_name"
              nameInputValue={values.cert_3_name}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <Button variant="secondary" onClick={() => setOpen({ childComponent: null, open: false })}>Cancel</Button>
        <Button type="submit" className="ml-4" onClick={handleSubmit}>{isEdit ? "Save" : "Create"}</Button>
      </div>
    </form>
  );
}
